import CodonationSelection from './CodonationSelection'

export default CodonationSelection
